export const LOGIN = "/login";
export const NEW_RESIDENTS_ASSOCIATION = "/new_residents_association";
export const EDIT_RESIDENTS_ASSOCIATION = "/edit_residents_association/:id";
export const RESIDENTS_ASSOCIATIONS = "/";
export const RESIDENTS_ASSOCIATION_INFO = "/residents_associations/:id";
export const NEW_ACCOUNT =
  "/residents_associations/:residentsAssociationId/new_account";
export const EDIT_ACCOUNT = "/edit_account/:id";
